/* eslint-disable */
import React from "react";
import { selectionpng } from "../../../assets";
interface ExistsOwnMemberModelProps {
	onClose: () => void;
	dependentData: any;
	newCoverageLabel: string | null;
	newTotalPremium: number | null;
	payFrequency: string;
}

const ExistsDependentModelVEB: React.FC<ExistsOwnMemberModelProps> = ({
	onClose,
	dependentData,
	newCoverageLabel,
	newTotalPremium,
	payFrequency
}) => {
	const hasMultiple = dependentData?.length > 1;

	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "rgba(0, 0, 0, 0.6)",
				backdropFilter: "blur(4px)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				zIndex: 1000,
				padding: "20px",
				animation: "fadeIn 0.2s ease-out"
			}}
		>
			<style>{`
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
            `}</style>

			<div
				style={{
					backgroundColor: "#ffffff",
					borderRadius: "16px",
					boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
					maxWidth: "520px",
					width: "100%",
					position: "relative",
					overflow: "hidden",
					animation: "slideUp 0.3s ease-out"
				}}
			>
				<div style={{ height: "4px", background: "linear-gradient(90deg, #f59e0b 0%, #d97706 100%)" }} />

				<div style={{ padding: "32px" }}>
					{/* Icon */}
					<div
						style={{
							width: "80px",
							height: "80px",
							margin: "0 auto 24px",
							backgroundColor: "#fef3c7",
							borderRadius: "50%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							border: "2px solid #fde68a"
						}}
					>
						<img
							src={selectionpng}
							alt="Warning"
							style={{ width: "40px", height: "40px", objectFit: "contain" }}
						/>
					</div>

					{/* Title */}
					<h2
						style={{
							margin: "0 0 8px 0",
							fontSize: "1.5rem",
							color: "#111827",
							fontWeight: "700",
							textAlign: "center"
						}}
					>
						Attention Required
					</h2>
					<p style={{ margin: "0 0 24px 0", fontSize: "0.95rem", color: "#6b7280", textAlign: "center" }}>
						We found existing coverage for your dependent{hasMultiple ? "s" : ""}
					</p>

					{/* Dependents List */}
					{dependentData?.length > 0 ? (
						<div
							style={{
								backgroundColor: "#f9fafb",
								borderRadius: "12px",
								padding: "20px",
								marginBottom: "24px",
								border: "1px solid #e5e7eb"
							}}
						>
							<h3
								style={{
									margin: "0 0 16px 0",
									fontSize: "0.75rem",
									fontWeight: "600",
									color: "#374151",
									textTransform: "uppercase",
									letterSpacing: "0.05em"
								}}
							>
								{hasMultiple ? "Affected Dependents" : "Affected Dependent"}
							</h3>
							<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
								{dependentData.map((dependent: any, index: number) => (
									<div
										key={index}
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											backgroundColor: "#ffffff",
											padding: "16px",
											borderRadius: "8px",
											border: "1px solid #e5e7eb",
											boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
										}}
									>
										<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
											<div
												style={{
													width: "40px",
													height: "40px",
													backgroundColor: "#fef3c7",
													borderRadius: "50%",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													fontSize: "1rem",
													fontWeight: "600",
													color: "#d97706"
												}}
											>
												{dependent?.first_name?.[0]}
												{dependent?.last_name?.[0]}
											</div>
											<div>
												<p
													style={{
														margin: 0,
														fontSize: "0.95rem",
														fontWeight: "600",
														color: "#111827"
													}}
												>
													{dependent?.first_name} {dependent?.last_name}
												</p>
											</div>
										</div>
										<span
											style={{
												backgroundColor: "#fef3c7",
												color: "#92400e",
												padding: "6px 12px",
												borderRadius: "20px",
												fontSize: "0.75rem",
												fontWeight: "600",
												textTransform: "capitalize"
											}}
										>
											{dependent?.relationship || "Employee"}
										</span>
									</div>
								))}
							</div>
						</div>
					) : (
						<div
							style={{
								backgroundColor: "#f9fafb",
								borderRadius: "12px",
								padding: "24px",
								marginBottom: "24px",
								textAlign: "center",
								color: "#6b7280"
							}}
						>
							No dependents found.
						</div>
					)}

					{/* ── NEW: Updated Coverage & Premium Card ── */}
					{(newCoverageLabel || newTotalPremium !== null) && (
						<div
							style={{
								backgroundColor: "#f0fdf4",
								border: "1px solid #86efac",
								borderRadius: "8px",
								padding: "16px",
								marginBottom: "24px",
								display: "flex",
								flexDirection: "column",
								gap: "12px"
							}}
						>
							<p
								style={{
									margin: 0,
									fontSize: "0.75rem",
									fontWeight: "600",
									color: "#166534",
									textTransform: "uppercase",
									letterSpacing: "0.05em"
								}}
							>
								Updated Enrollment Summary
							</p>
							<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
								<div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
									<span style={{ fontSize: "0.8rem", color: "#6b7280" }}>New Coverage</span>
									<span style={{ fontSize: "0.95rem", fontWeight: "600", color: "#111827" }}>
										{newCoverageLabel ?? "—"}
									</span>
								</div>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "4px",
										alignItems: "flex-end"
									}}
								>
									<span style={{ fontSize: "0.8rem", color: "#6b7280" }}>
										{payFrequency ? `${payFrequency} Premium` : "New Premium"}
									</span>
									<span style={{ fontSize: "1.25rem", fontWeight: "700", color: "#16a34a" }}>
										${newTotalPremium?.toFixed(2) ?? "—"}
									</span>
								</div>
							</div>
						</div>
					)}

					{/* Warning Message */}
					<div
						style={{
							backgroundColor: "#fffbeb",
							border: "1px solid #fcd34d",
							borderRadius: "8px",
							padding: "16px",
							marginBottom: "24px",
							display: "flex",
							gap: "12px",
							alignItems: "flex-start"
						}}
					>
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							style={{ flexShrink: 0, marginTop: "2px" }}
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
								fill="#f59e0b"
							/>
						</svg>
						<div>
							<p style={{ margin: "0 0 4px 0", fontSize: "0.9rem", fontWeight: "600", color: "#92400e" }}>
								Benefit Restriction
							</p>
							<p style={{ margin: 0, fontSize: "0.85rem", color: "#a16207", lineHeight: "1.5" }}>
								{hasMultiple
									? "These dependents are already covered in this benefit plan. You will not be able to claim benefits for them."
									: "This dependent is already covered in this benefit plan. You will not be able to claim benefits for them."}
							</p>
						</div>
					</div>

					{/* Help Section */}
					<div
						style={{
							backgroundColor: "#eff6ff",
							borderRadius: "8px",
							padding: "16px",
							marginBottom: "24px",
							display: "flex",
							gap: "12px",
							alignItems: "flex-start"
						}}
					>
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							style={{ flexShrink: 0, marginTop: "2px" }}
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
								fill="#3b82f6"
							/>
						</svg>
						<p style={{ margin: 0, fontSize: "0.85rem", color: "#1e40af", lineHeight: "1.5" }}>
							<strong>Need help?</strong> If you believe this is an error, please contact your HR
							department for assistance.
						</p>
					</div>

					{/* Action Button */}
					<button
						onClick={onClose}
						style={{
							width: "100%",
							backgroundColor: "#111827",
							color: "#ffffff",
							border: "none",
							padding: "14px 24px",
							borderRadius: "8px",
							cursor: "pointer",
							fontSize: "0.95rem",
							fontWeight: "600",
							transition: "all 0.2s ease",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: "8px"
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.backgroundColor = "#374151";
							e.currentTarget.style.transform = "translateY(-1px)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.backgroundColor = "#111827";
							e.currentTarget.style.transform = "translateY(0)";
						}}
					>
						<span>I Understand, Continue</span>
						<svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
							<path
								fillRule="evenodd"
								d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
								clipRule="evenodd"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
};
export default ExistsDependentModelVEB;
